import { render, staticRenderFns } from "./ThingTypeTabComponent.vue?vue&type=template&id=64f02c32&scoped=true"
import script from "./ThingTypeTabComponent.js?vue&type=script&lang=js&external"
export * from "./ThingTypeTabComponent.js?vue&type=script&lang=js&external"
import style0 from "./ThingTypeTabComponent.vue?vue&type=style&index=0&id=64f02c32&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f02c32",
  null
  
)

export default component.exports